import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { AccordionComponent } from '../../atoms/accordion/accordion.component';
import {
  AccordionExpandPosition,
  AccordionItem,
} from '../../../models/accordion.models';

@Component({
  selector: 'ui-accordion-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AccordionComponent],
  template: `
    <ui-accordion
      [panels]="panelsSignal()"
      [expandIconPosition]="expandIconPosition()"
      (onSubitemClick)="selectSubitem($event)"
    />
  `,
})
export class AccordionMenu {
  panels = input.required<AccordionItem[]>();
  expandIconPosition = input.required<AccordionExpandPosition>();

  onSubitemSelect = output<{
    itemId: string | null;
    subitemId: string | null;
    itemActive?: boolean;
  }>();

  panelsSignal = signal<AccordionItem[]>([]);

  constructor() {
    effect(() => {
      this.panelsSignal.set(this.panels());
    })
  }

  selectSubitem(event: { panelIndex: number; subitemIndex: number }) {
    const { panelIndex, subitemIndex } = event;
    const panels = this.panelsSignal();
    let panelId = null;
    let subitemId = null;
    let itemActive = false
    panels.map((panel, panelCurrentIndex) => {
      if(panelCurrentIndex === panelIndex){
        panel.items?.map((subitem, subitemCurrentIndex) => {
          subitem.active = subitem.active === true ? false :
            panelCurrentIndex === panelIndex &&
            subitemCurrentIndex === subitemIndex;
          if (panelCurrentIndex === panelIndex) panelId = panel.id;
          if (panelCurrentIndex === panelIndex && subitemCurrentIndex === subitemIndex) itemActive = subitem.active;
          if (subitemCurrentIndex === subitemIndex) subitemId = subitem.id;
        });
      }
      else {
        panel.items?.map((subitem) => {
          subitem.active = false;
        });
      }
    });
    this.onSubitemSelect.emit({
      itemId: panelId,
      subitemId: subitemId,
      itemActive: itemActive,
    });
    this.panelsSignal.set(panels);
  }
}
